import api from '~/services/api';

const applyPromoCode = (code: string) =>
  api.request({
    data: {
      code,
    },
    method: 'POST',
    url: `/apply_promo_code/`,
  });

const replacePromoCode = (code: string) =>
  api.request({
    data: {
      code,
    },
    method: 'POST',
    url: `/replace_promo_code/`,
  });

export { applyPromoCode, replacePromoCode };
